import { render } from "./Testing.vue?vue&type=template&id=2f8a3e69&scoped=true"
import script from "./Testing.vue?vue&type=script&lang=js"
export * from "./Testing.vue?vue&type=script&lang=js"

import "./Testing.vue?vue&type=style&index=0&id=2f8a3e69&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8a3e69"]])

export default __exports__